var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("HeaderLandingNew", { attrs: { "custom-class": "z-index-2" } }),
      _vm._v(" "),
      _c("HeaderLandingContent"),
      _vm._v(" "),
      _c("div", { staticClass: "container-section " }, [
        _c(
          "div",
          { staticClass: "content-section-2" },
          [
            _c(
              "b-container",
              {
                staticClass: "mt-5 mb-5",
                staticStyle: { "min-height": "65vh" },
                attrs: { fluid: "" }
              },
              [
                !_vm.registerSuccess
                  ? _c(
                      "b-row",
                      { attrs: { "align-h": "center" } },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c(
                              "b-form",
                              {
                                staticClass:
                                  "d-flex flex-column align-items-center",
                                on: {
                                  submit: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "event",
                                        undefined,
                                        $event.key,
                                        undefined
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.register($event)
                                  }
                                }
                              },
                              [
                                _c(
                                  "b-nav",
                                  {
                                    staticClass:
                                      "mb-5 justify-content-center nav-signin",
                                    attrs: { pills: "" }
                                  },
                                  [
                                    _c(
                                      "b-nav-item",
                                      { attrs: { active: "" } },
                                      [_vm._v("Sign Up")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-nav-item",
                                      { attrs: { href: "/#/login" } },
                                      [_vm._v("Log In")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.showFormEmail
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-100 d-flex justify-content-start align-items-center",
                                          staticStyle: {
                                            "margin-bottom": "32px"
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "cursor-pointer text-decoration-none",
                                              staticStyle: { color: "#4d4d4d" },
                                              on: {
                                                click: function($event) {
                                                  _vm.showFormEmail = false
                                                  _vm.$v.form.$reset()
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "icon-back",
                                                staticStyle: {
                                                  "margin-right": "20px"
                                                },
                                                attrs: {
                                                  icon: ["fas", "arrow-left"]
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "20px",
                                                    "line-height": "24px"
                                                  }
                                                },
                                                [_vm._v("Back")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "font-weight-bolder mb-4"
                                        },
                                        [_vm._v("Sign Up with Email")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-4 w-100",
                                          attrs: { id: "input-group-firstname" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-firstname",
                                              state: _vm.validateState(
                                                "first_name"
                                              ),
                                              type: "text",
                                              placeholder: "Enter First Name",
                                              "aria-describedby":
                                                "input-firstname-feedback"
                                            },
                                            model: {
                                              value:
                                                _vm.$v.form.first_name.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form.first_name,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.first_name.$model"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              staticClass: "text-left",
                                              attrs: {
                                                id: "input-firstname-feedback"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "This is a required field."
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-4 w-100",
                                          attrs: { id: "input-group-lastname" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-lastname",
                                              state: _vm.validateState(
                                                "last_name"
                                              ),
                                              type: "text",
                                              placeholder: "Enter Last Name",
                                              "aria-describedby":
                                                "input-lastname-feedback"
                                            },
                                            model: {
                                              value:
                                                _vm.$v.form.last_name.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form.last_name,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.last_name.$model"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              staticClass: "text-left",
                                              attrs: {
                                                id: "input-lastname-feedback"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "This is a required field."
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-4 w-100",
                                          attrs: { id: "input-group-email" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-email",
                                              state: _vm.validateState("email"),
                                              type: "email",
                                              placeholder: "Enter email",
                                              "aria-describedby":
                                                "input-email-feedback",
                                              disabled: _vm.isSocial
                                            },
                                            model: {
                                              value: _vm.$v.form.email.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form.email,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression: "$v.form.email.$model"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              staticClass: "text-left",
                                              attrs: {
                                                id: "input-email-feedback"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "This is a required field and must be a valid email."
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-4 w-100",
                                          attrs: { id: "input-group-country" }
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              id: "input-country",
                                              options: _vm.listCountry,
                                              state: _vm.validateState(
                                                "country"
                                              ),
                                              "aria-describedby":
                                                "input-country-feedback"
                                            },
                                            on: { change: _vm.selectCountry },
                                            model: {
                                              value: _vm.$v.form.country.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form.country,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.country.$model"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              staticClass: "text-left",
                                              attrs: {
                                                id: "input-country-feedback"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "This is a required field."
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !!_vm.form.country
                                        ? _c(
                                            "b-form-group",
                                            {
                                              staticClass:
                                                "position-relative mb-4 w-100",
                                              attrs: { id: "input-group-phone" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "position-absolute phone-country"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.phone_country
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                staticStyle: {
                                                  "padding-left": "54px"
                                                },
                                                attrs: {
                                                  id: "input-phone",
                                                  state: _vm.validateState(
                                                    "phone_number"
                                                  ),
                                                  type: "text",
                                                  placeholder:
                                                    "Enter Phone Number",
                                                  "aria-describedby":
                                                    "input-phone-feedback"
                                                },
                                                model: {
                                                  value:
                                                    _vm.$v.form.phone_number
                                                      .$model,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.$v.form.phone_number,
                                                      "$model",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "$v.form.phone_number.$model"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-invalid-feedback",
                                                {
                                                  staticClass: "text-left",
                                                  attrs: {
                                                    id: "input-phone-feedback"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "must be a numeric character."
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-4 w-100",
                                          attrs: { id: "input-group-gender" }
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              id: "input-gender",
                                              options: _vm.listGender
                                            },
                                            model: {
                                              value: _vm.form.gender,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "gender",
                                                  $$v
                                                )
                                              },
                                              expression: "form.gender"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.isSocial
                                        ? _c(
                                            "b-form-group",
                                            {
                                              staticClass:
                                                "mb-4 position-relative w-100",
                                              attrs: {
                                                id: "input-group-password"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: _vm.showPassword
                                                    ? "text"
                                                    : "password",
                                                  id: "input-password",
                                                  placeholder: "Enter Password",
                                                  state: _vm.validateState(
                                                    "password"
                                                  ),
                                                  "aria-describedby":
                                                    "input-password-feedback"
                                                },
                                                model: {
                                                  value:
                                                    _vm.$v.form.password.$model,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.$v.form.password,
                                                      "$model",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "$v.form.password.$model"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "position-absolute show-hide-password",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.showPassword = !_vm.showPassword
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "text-dark",
                                                    attrs: {
                                                      icon: [
                                                        "fa",
                                                        _vm.showPassword
                                                          ? "eye-slash"
                                                          : "eye"
                                                      ]
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-invalid-feedback",
                                                {
                                                  staticClass: "text-left",
                                                  attrs: {
                                                    id:
                                                      "input-password-feedback"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "This is a required field and have a minimum 6 characters."
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isSocial
                                        ? _c(
                                            "b-form-group",
                                            {
                                              staticClass:
                                                "mb-4 position-relative w-100",
                                              attrs: {
                                                id:
                                                  "input-group-confirmpassword"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: _vm.showConfirmPassword
                                                    ? "text"
                                                    : "password",
                                                  id: "input-confirmpassword",
                                                  placeholder:
                                                    "Enter Confirm Password",
                                                  state: _vm.validateState(
                                                    "confirm_password"
                                                  ),
                                                  "aria-describedby":
                                                    "input-confirmpassword-feedback"
                                                },
                                                model: {
                                                  value:
                                                    _vm.$v.form.confirm_password
                                                      .$model,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.$v.form
                                                        .confirm_password,
                                                      "$model",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "$v.form.confirm_password.$model"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "position-absolute show-hide-password",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.showConfirmPassword = !_vm.showConfirmPassword
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "text-dark",
                                                    attrs: {
                                                      icon: [
                                                        "fa",
                                                        _vm.showConfirmPassword
                                                          ? "eye-slash"
                                                          : "eye"
                                                      ]
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-invalid-feedback",
                                                {
                                                  staticClass: "text-left",
                                                  attrs: {
                                                    id:
                                                      "input-confirmpassword-feedback"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "This is a required field and must match the password field."
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn-block",
                                          attrs: {
                                            type: "submit",
                                            variant: "primary"
                                          }
                                        },
                                        [_vm._v("Sign Up")]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "font-weight-bolder mb-4"
                                        },
                                        [_vm._v("Registration")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn-block btn-social",
                                          attrs: {
                                            type: "button",
                                            variant: "default"
                                          },
                                          on: { click: _vm.signUpFB }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/fb-icon.svg"),
                                              alt: "logo"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Sign Up with Facebook\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn-block btn-social",
                                          attrs: {
                                            type: "button",
                                            variant: "default"
                                          },
                                          on: { click: _vm.signUpGoogle }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/google-icon.svg"),
                                              alt: "logo"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Sign Up with Google\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn-block btn-social",
                                          attrs: {
                                            type: "button",
                                            variant: "default"
                                          },
                                          on: { click: _vm.signUpApple }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/apple-icon.svg"),
                                              alt: "logo"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Sign Up with Apple\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn-block btn-social",
                                          attrs: {
                                            type: "button",
                                            variant: "default"
                                          },
                                          on: { click: _vm.toggleFormEmail }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/mail-icon.svg"),
                                              alt: "logo"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Sign Up with Email\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center",
                                          staticStyle: {
                                            "margin-top": "56px",
                                            "margin-bottom": "23px",
                                            "font-size": "16px",
                                            "line-height": "19px"
                                          }
                                        },
                                        [_vm._v("Already have account?")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "button",
                                            variant: "primary"
                                          },
                                          on: { click: _vm.goToLogin }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Login\n                "
                                          )
                                        ]
                                      )
                                    ],
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "border-bottom border-dark mb-3",
                                  staticStyle: { "margin-top": "89px" }
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "Download MusicVerse. Your one-stop app for sacred music"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "justify-content-center align-items-center flex-column flex-sm-row"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo",
                                        attrs: {
                                          href: _vm.appStoreUrl,
                                          "aria-label": "App Store",
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "content-logo",
                                          attrs: {
                                            src: require("@/assets/applestore-logo.png"),
                                            alt: "App Store"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo",
                                        attrs: {
                                          href: _vm.googlePlayUrl,
                                          "aria-label": "Google Play",
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "content-logo",
                                          attrs: {
                                            src: require("@/assets/googleplay-logo.png"),
                                            alt: "Google Play"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "mt-3 mt-xl-0 content-logo radius",
                                        attrs: {
                                          href: _vm.appGalleryUrl,
                                          "aria-label": "App Gallery",
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "content-logo radius",
                                          attrs: {
                                            src: require("@/assets/huawei-logo.png"),
                                            alt: "App Gallery"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.registerSuccess
                  ? _c(
                      "b-row",
                      {
                        staticStyle: {
                          "margin-bottom": "40px",
                          "text-align": "center"
                        },
                        attrs: { "align-h": "center" }
                      },
                      [
                        _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                          _c("h2", { staticClass: "font-weight-bolder mb-5" }, [
                            _vm._v("Thank You for Registering at MusicVerse!")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n              We have sent an email with a confirmation link to the email address you registered. Please click the link to complete the registration process.\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n              If the email is not found in your email inbox, please check your spam folder.\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n              If email is not received at all, click here to "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "cursor-pointer",
                                on: { click: _vm.resend }
                              },
                              [_vm._v("resend")]
                            ),
                            _vm._v(
                              " to " +
                                _vm._s(_vm.form.email) +
                                ".\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-primary w-50 mt-3",
                              attrs: { href: "/#/login" }
                            },
                            [_vm._v("Go to Login")]
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("FooterLandingNew")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6106551a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6106551a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Registration.vue
// module id = null
// module chunks = 